import script from "./GroupCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupCardModal.vue?vue&type=script&setup=true&lang=js"

import "./GroupCardModal.vue?vue&type=style&index=0&id=1b5e3eb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5e3eb4"]])

export default __exports__